/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EViewPort } from "../types/EViewPort.ts";

/**
 * @description 1 = Desktop | 2 = Mobile |
 */
export const eViewPortSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe("1 = Desktop | 2 = Mobile | ") as unknown as ToZod<EViewPort>;
